import script from "./ResearchToolItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchToolItem.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchToolItem.vue?vue&type=style&index=0&id=5e3e3635&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3e3635"]])

export default __exports__